/*
* @Author: Abhi Bhatt
* @Date:   2021-12-03 11:26:41
* @Last Modified by:   Abhi Bhatt
* @Last Modified time: 2021-12-31 18:37:07
*/
export function seo(data = {}) {
  data.title = data.title || 'Club Miracle';
  data.metaDescription = data.metaDescription || 'Club Miracle';
  data.metaKeywords = data.metaKeywords || 'Club Miracle';

  document.title = data.title;
  document.querySelector('meta[name="description"]').setAttribute('content', data.metaDescription);
  document.querySelector('meta[name="keywords"]').setAttribute('content', data.metaKeywords);
}